const inkeep_ai_bot = {
    intro_message: 'Hi, ich bin Logto AI!\n\nIch bin ein KI-Assistent, der auf Dokumentation, Hilfeartikel und andere Inhalte trainiert wurde.\n\nFrage mich alles über `Logto`.',
    chat_placeholder: 'Fragen Sie Logto AI nach einer Schritt-für-Schritt-Anleitung',
    disclaimer_label: 'Logto AI Haftungsausschluss',
    disclaimer_tooltip: 'Antworten werden von KI generiert und könnten einer Überprüfung bedürfen.',
    example_questions_label: 'Beispielfragen',
    example_questions: [
        'Schnellstartanleitung für die Einrichtung von Logto',
        'Konfigurieren der Multi-Tenancy-Architektur',
        'Wie integriert man ein Benutzerprofil?',
    ],
    stop: 'Stoppen',
    clear: 'Neu anfangen',
    get_help: 'Hilfe erhalten',
    copy_chat: 'Kopieren',
    ask_ai_label: 'KI fragen',
    contact: 'Kontakt',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
